//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from "vuex";
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  name: "AdminLayout",
  components: { ConfirmDialog },
  methods: {
    logout () {
      this.$store.dispatch("updateJwtToken", '')
      this.$router.push({ name: 'login'})
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState(['isLoading'])
  },
  beforeRouteEnter(from, to, next) {
    console.log('Before route enter admin')
    next()
  },
  mounted() {
    console.log('Admin mounted ')
  }
}
